import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data = null) {
        if (!data || Object.keys(data).length === 0) {
            return axios.get(`${API_URL}/worker-tasks`, { headers: authHeader() });
        }
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/worker-tasks?${queryString}`;
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/worker-tasks/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/worker-tasks`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/worker-tasks/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/worker-tasks/${id}`, { headers: authHeader() });
    },
    addPayment(id, amount) {
        return axios.post(`${API_URL}/worker-tasks/${id}/add-payment`, { amount }, { headers: authHeader() });
    },
    exportData(filters = {}) {
        return axios.post(`${API_URL}/export/worker-tasks`, filters, { 
            headers: authHeader(),
            responseType: 'blob' // Importante para descargar archivos
        });
    },
};
